import { render, staticRenderFns } from "./appHeader0Edited.vue?vue&type=template&id=85bc4192&"
import script from "./appHeader0Edited.vue?vue&type=script&lang=js&"
export * from "./appHeader0Edited.vue?vue&type=script&lang=js&"
import style0 from "./appHeader0Edited.vue?vue&type=style&index=0&id=85bc4192&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports